import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import DividerLine from '../components/divider-line.js';
import { d as dividerStyles } from '../withSafariSvgCaretFixer-21cd658a.js';
import classNames from 'classnames';
import { ROOT } from '../dataHooks.js';
import 'prop-types';
import '../defaults.js';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';

const DividerViewer = ({ componentData }) => {
  var _a, _b, _c;
  const { isMobile } = useContext(RicosContext);
  const lineStyle = (_a = componentData.lineStyle) == null ? void 0 : _a.toLowerCase();
  const className = classNames(
    dividerStyles["divider-container"],
    dividerStyles[`divider-container--${lineStyle}`],
    isMobile && dividerStyles["divider-container--mobile"]
  );
  return /* @__PURE__ */ React.createElement("div", { className, "data-hook": `${ROOT} divider-${lineStyle}` }, /* @__PURE__ */ React.createElement(
    DividerLine,
    {
      type: lineStyle,
      width: "100%",
      size: (_b = componentData.width) == null ? void 0 : _b.toLowerCase(),
      alignment: (_c = componentData.alignment) == null ? void 0 : _c.toLowerCase(),
      styles: dividerStyles,
      isMobile
    }
  ));
};

export { DividerViewer };
//# sourceMappingURL=divider-viewer.js.map
